import { useState } from "react"
import { useNavigate } from "react-router"
import { Plus } from "lucide-react"
import { useAuth } from "../auth/AuthProvider.js"
import { ServerList } from "../components/servers/ServerList.js"
import { CreateServerForm } from "../components/servers/CreateServerForm.js"
import { Button } from "../components/ui/Button.js"

/**
 * FR section 8, `/servers` ("Mis Servidores" en el nav de nivel superior).
 * Boton "Nuevo servidor" (TODO.md "Crear servidores desde la app") solo
 * visible para host_owner -- misma restriccion que POST /api/v1/servers
 * en el Gateway (decision explicita de Joanfer, no un Permission
 * delegable). Tras crear con exito, navega directo al server recien
 * creado en vez de solo refrescar la lista: un server nuevo en Crafty
 * tarda en aprovisionar, mejor UX ver su estado que la lista general.
 */
export function ServersPage() {
  const { user } = useAuth()
  const navigate = useNavigate()
  const [showCreate, setShowCreate] = useState(false)

  const canCreate = user?.systemRole === "host_owner"

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "var(--space-6)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: "var(--space-3)" }}>
        <h1 style={{ fontSize: "var(--text-3xl)" }}>Mis Servidores</h1>
        {canCreate && !showCreate && (
          <Button onClick={() => setShowCreate(true)}>
            <Plus size={16} aria-hidden />
            Nuevo servidor
          </Button>
        )}
      </div>

      {canCreate && showCreate && (
        <CreateServerForm
          onCreated={(serverId) => {
            setShowCreate(false)
            navigate(`/servers/${serverId}`)
          }}
          onCancel={() => setShowCreate(false)}
        />
      )}

      <ServerList />
    </div>
  )
}
